'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var hqoTheme = require('./hqo-theme-587e766d.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index_es = require('./index.es-1f72f6f2.js');

var ConditionContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n"])));
var ConditionIcon = styled__default(index_es.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  width: 16px !important;\n  margin: 0 24px 0 14px;\n"], ["\n  width: 16px !important;\n  margin: 0 24px 0 14px;\n"])));
var ConditionText = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: normal 12px/24px ", ";\n  display: flex;\n  align-items: center;\n  color: ", ";\n"], ["\n  font: normal 12px/24px ", ";\n  display: flex;\n  align-items: center;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (props) { return "" + props.color; });
var templateObject_1, templateObject_2, templateObject_3;

var passwordLengthValidator = new RegExp(/^.{8,}/g);
var hasNumberValidator = new RegExp(/\d{1,}/g);
var hasSpecialCharacterValidator = new RegExp(/\W{1,}/g);
var hasMixedCaseValidator = new RegExp(/(?=.*[a-z])(?=.*[A-Z])/g);
// eslint-disable-next-line max-len
var isPasswordLengthValid = function (password) { return password.match(passwordLengthValidator); };
var isPasswordNumberValid = function (password) { return password.match(hasNumberValidator); };
// eslint-disable-next-line max-len
var isPasswordSpecialCharacterValid = function (password) { return password.match(hasSpecialCharacterValidator); };
var isPasswordCaseValid = function (password) { return password.match(hasMixedCaseValidator); };

var CONDITION_ICON = ['fas', 'check-circle'];
var UnthemedPasswordCheckList = function (_a) {
    var password = _a.password, setPasswordValid = _a.setPasswordValid, theme = _a.theme, passwordRequirementText = _a.passwordRequirementText;
    var _b = theme.colors, $primary = _b.$primary, $greyDark = _b.$greyDark;
    var isEightChars = isPasswordLengthValid(password);
    var isNumber = isPasswordNumberValid(password);
    var isSpecialChar = isPasswordSpecialCharacterValid(password);
    var isProperCase = isPasswordCaseValid(password);
    var setIconColor = function (condition) { return (condition ? $primary : $greyDark); };
    var setTextColor = function (condition) { return (condition
        ? hqoTheme.hqoTheme.colors.greys.adminBlack
        : $greyDark); };
    React.useEffect(function () {
        setPasswordValid(!!(isEightChars && isNumber && isSpecialChar && isProperCase));
    }, [isEightChars, isNumber, isSpecialChar, isProperCase, setPasswordValid]);
    return (React__default.createElement("div", { "data-testid": "password-check-list-id" },
        React__default.createElement(ConditionContainer, null,
            React__default.createElement(ConditionIcon, { icon: CONDITION_ICON, color: setIconColor(isProperCase) }),
            React__default.createElement(ConditionText, { color: setTextColor(isProperCase) }, passwordRequirementText.upperLower)),
        React__default.createElement(ConditionContainer, null,
            React__default.createElement(ConditionIcon, { icon: CONDITION_ICON, color: setIconColor(isNumber) }),
            React__default.createElement(ConditionText, { color: setTextColor(isNumber) }, passwordRequirementText.oneNumber)),
        React__default.createElement(ConditionContainer, null,
            React__default.createElement(ConditionIcon, { icon: CONDITION_ICON, color: setIconColor(isSpecialChar) }),
            React__default.createElement(ConditionText, { color: setTextColor(isSpecialChar) }, passwordRequirementText.specialCharacter)),
        React__default.createElement(ConditionContainer, null,
            React__default.createElement(ConditionIcon, { icon: CONDITION_ICON, color: setIconColor(isEightChars) }),
            React__default.createElement(ConditionText, { color: setTextColor(isEightChars) }, passwordRequirementText.eightCharacters))));
};
var PasswordCheckList = styled.withTheme(UnthemedPasswordCheckList);

exports.PasswordCheckList = PasswordCheckList;
